import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, DISCHARGE_SUMMARY_DETAIL_PATH, DISCHARGE_SUMMARY_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const DischargeSummaryPage = lazy(() => import('@features/HealthRecords/DischargeSummary/pages/DischargeSummaryPage'));

const DischargeSummaryDetailPage = lazy(
  () => import('@features/HealthRecords/DischargeSummary/pages/DischargeSummaryDetail')
);

export const DISCHARGE_SUMMARY_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <DischargeSummaryPage />,
    displayTitle: () => 'Discharge Summary',
    pageType: PageType.PRIVATE,
    path: DISCHARGE_SUMMARY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.dischargeSummary,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <DischargeSummaryDetailPage />,
    displayTitle: () => 'Discharge Summary Details',
    pageType: PageType.PRIVATE,
    path: DISCHARGE_SUMMARY_DETAIL_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.dischargeSummary,
  },
];
